module.exports = __webpack_public_path__ + "media/images/emoticons/fastfood-c1967127051841747af2e408174cd942.gif";